export const logPageLoadEvents = (pageName, events) => {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const cmp = params.get('cmp');
  var qd = {};
  if (location.search) location.search.substr(1).split(/[\s?&]+/).forEach(function(item) {
      var s = item.split("="),
          k = s[0],
          v = s[1] && decodeURIComponent(s[1]); //  null-coalescing / short-circuit
      (qd[k] = qd[k] || []).push(v) // null-coalescing / short-circuit
  })

  try {
    if (typeof window === "undefined" || !window.s) {
      return;
    }
    let s = window.s;
    // if(events && JSON.stringify(events) !== {}) {
    if(events && Object.keys(events).length) {
      for(let key in events) {
        if(events.hasOwnProperty(key)) {
          s[key] = events[key];
        }
      }
    }
    // let corpAllocationInfo = (cookies && cookies.get("corpAllocationInfo"));
    // corpAllocationInfo = corpAllocationInfo ? corpAllocationInfo: '';
    // s.pageName = 'mybusinessadmin:' +pageName+ '|corporate';
    s.pageName = `${pageName}|mypartner`;
    s.eVar1 = window.navigator && window.navigator.userAgent;
    s.eVar27 = window.location.href;
    if(qd.cmp) s.eVar45 = qd.cmp; 
    // s.eVar47 = corpAllocationInfo + (s.eVar47 ? s.eVar47:'');
    s.events = "event504";
    let s_code = s.t();
    if (s_code) window.document.write(s_code);
  } catch (e) {
    // do nothing
  }
};


export const sendEvarData = (events, isClickEvent=false, extraData={}) => {
  try {
    if (typeof window === "undefined" || !window.s) {
      return;
    }
    let s = window.s;
    if (isClickEvent) {
      logOmniClick(events['prop54'], events)
    }
    else {
      // if(events && JSON.stringify(events) !== {}) {
      if(events && Object.keys(events).length) {
        for(let key in events) {
          if(events.hasOwnProperty(key)) {
            s[key] = events[key];
          }
        }
      }
      if(extraData['products']) {
        s.products = `;HOT | ${extraData['products']}`
      }

      if(extraData['pageName']) {
        s.pageName = extraData['pageName'];
      }
      
      let s_code = s.t();
      if (s_code) window.document.write(s_code);
    }
    
  } catch (e) {
    // do nothing
  }
};

export const logOmniClick = (clickEventName, omniclickEventParam) => {
  try {
    if (typeof window === "undefined" || !window.s) return;
    let s = window.s;
    if (clickEventName && omniclickEventParam) {
      s.linkTrackVars = "channel,eVar1,eVar15,eVar24,eVar34,prop24,prop54,eVar22,eVar37";
      for (let key  in omniclickEventParam) {
        if (omniclickEventParam.hasOwnProperty(key)) {
          s.linkTrackVars += "," + key;
          s[key] = omniclickEventParam[key];
        }
      }
      /**
       * Handling variant landing page
       * Will not effect handling from other pages
       */
      s.tl(this, "o", clickEventName);
    }
  } catch (e) {
    console.log("tracking failed", e);
  }
};

